var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.stepList.length,
          expression: "stepList.length"
        }
      ],
      staticClass: "merge-depth-wrapper"
    },
    [
      _vm._v("\n    " + _vm._s(_vm.$t("tradeCenter.mergeDepth")) + "\n    "),
      _c(
        "div",
        {
          staticClass: "select-list __pointer",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.toggleShowStepList($event)
            }
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("tradeCenter.depthStep", { step: _vm.step })) +
              "\n        "
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowStepList,
                  expression: "isShowStepList"
                }
              ],
              staticClass: "list"
            },
            _vm._l(_vm.stepList, function(s, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "item",
                  on: {
                    click: function($event) {
                      return _vm.setStep(s)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("tradeCenter.depthStep", { step: s }))
                  )
                ]
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }